import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RadioComponentDef } from '@df/ui/form/radio/radio.component.def';
@Component({
    selector: 'radio2',
    templateUrl: './radio2.html',
    styleUrls: ['radio2.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgClass]
})
export class Radio2Component extends RadioComponentDef {
    @Input()
    centerText?: boolean;

    @Input()
    context?: 'default' | 'basket';

    protected get isBasketContext(): boolean {
        return this.context === 'basket';
    }
}
